export default "__VITE_ASSET__b2b7b9e7__"